exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mission-report-numbers{text-align:right}.mission-report-numbers-addon{position:relative}.mission-report-numbers-mark{background-color:#EE303C;position:absolute;left:-2px;top:-1px;bottom:-1px;width:5px;border-top-left-radius:5px;border-bottom-left-radius:5px}\n", ""]);

// exports
